export default __webpack_public_path__ + "static/media/green-face.305f4fc5.png";